import * as yup from 'yup';

export const AccountValidationSchema = [
    yup.object({
        contactName: yup.string().required('Contact Name is required'),
        email: yup.string().email('Email is invalid').required('Email is required'),
        telephone: yup.string().required('Telephone is required').matches(/^\d+$/, 'Telephone can only contain numbers.').max(10, "Telephone must be less than 10 characters"),
        username: yup.string().required('Username is required').matches(/^\S*$/, 'Whitespaces are not allowed'),
    })
]

export interface UsernameCheckRequestModel {
    UserId?: string,
    SuggestedUsername: string
}